var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fullscreen-overlay-frame',{attrs:{"title":_vm.data?.name,"icon":"feed","color":"primary","centered":"","closable":""},on:{"close":_vm.closeOverlay},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"meetings-iframe-container",attrs:{"id":'meetings-iframe-container-' + _vm.data.id}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }